import React, { createContext, useContext, useMemo, useState } from "react";
import { translations, type Lang, format } from "../i18n/translations";

interface LangContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string, vars?: Record<string, string | number>) => string;
}

const LangContext = createContext<LangContextType>({} as LangContextType);

export const LangProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [lang, _setLang] = useState<Lang>(() => {
    const saved = localStorage.getItem("lang") as Lang | null;
    return saved && (saved === "oz" || saved === "uz" || saved === "ru") ?
        saved
      : "oz";
  });

  const setLang = (l: Lang) => {
    _setLang(l);
    localStorage.setItem("lang", l);
  };

  const t = useMemo(() => {
    return (key: string, vars?: Record<string, string | number>) => {
      const dict = translations[lang];
      const base = dict[key] ?? translations.oz[key] ?? key;
      return format(base, vars);
    };
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
